import create from 'zustand';
import { supabase } from '../integrations/supabase/client';

const useFeedStore = create((set, get) => ({
  feeds: [],
  categories: ['AI行业动态', 'Web3动态', '企业家动态', '投资人动态', '一人公司动态'],  // Default categories, displayed even without data
  isLoading: false,
  error: null,
  
  // Get all feeds
  fetchFeeds: async () => {
    // 检查网络连接状态
    if (!navigator.onLine) {
      console.log('网络已断开，无法获取Feed数据');
      set({ 
        error: '网络连接已断开',
        isLoading: false 
      });
      return;
    }
    
    set({ isLoading: true });
    try {
      const { data, error } = await supabase
        .from('feed')
        .select('*');
        
      if (error) throw error;
      
      // Extract unique categories
      const categoriesMap = {};
      data?.forEach(feed => {
        if (feed.category) {
          categoriesMap[feed.category] = true;
        }
      });
      const uniqueCategories = Object.keys(categoriesMap);
      
      // If no category data, use default categories
      const allCategories = uniqueCategories.length > 0
        ? uniqueCategories
        : ['AI行业动态', 'Web3动态', '企业家动态', '投资人动态', '一人公司动态'];
      
      set({ 
        feeds: data || [],
        categories: allCategories,
        isLoading: false 
      });
    } catch (error) {
      console.error('Error fetching feeds:', error);
      set({ error: error.message, isLoading: false });
    }
  },
  
  // Get feeds by category
  getFeedsByCategory: (category) => {
    return get().feeds.filter(feed => feed.category === category);
  }
}));

export default useFeedStore; 